export default __webpack_public_path__ + "4b5c53e63e3449f8875b4bb6c48919ba.png";